import { useMutation } from "react-query";
import { getForReviewInvoiceById } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useGetForReviewInvoiceById = () => {
  return useMutation(getForReviewInvoiceById);
};
